import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default (props: { text: string; tooltip: string }) => (
  <OverlayTrigger overlay={<Tooltip>{props.tooltip}</Tooltip>}>
    <span>{props.text}</span>
  </OverlayTrigger>
);
